/**
 * BucketChip (PROD-1304) — the meal option a student ordered, as the bucket's
 * NAME inside a pastel chip tinted with the bucket's ONE shared color
 * (`menuBucketColorKey`: purple Main, green Veg, …). Always the LIGHT
 * colorway (`ordoLightBadgeClassName` = soft `bg-*-100` + `text-*-600`),
 * never a solid tile — these sit beside names on a line a worker scans for
 * an hour, so they must read at a glance without shouting. Color never
 * carries the meaning alone: the label is always printed inside the chip.
 */

import { menuBucketColorKey } from '@ordo/constants/menu-line-style'
import { ordoLightBadgeClassName } from '@ordo/ui/tag-chip'

import type { DeliverableLineBucket } from '@/lib/cafeteria/format'

export function BucketChip({ bucket }: { bucket: DeliverableLineBucket }) {
  return (
    <span
      data-bucket-code={bucket.code ?? undefined}
      className={ordoLightBadgeClassName(
        menuBucketColorKey(bucket.code),
        'inline-flex shrink-0 items-center whitespace-nowrap rounded-full px-2 py-0.5 text-sm font-medium leading-5',
      )}>
      {bucket.label}
    </span>
  )
}
